import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=610b8160&scoped=true"
import script from "./HelpPage.vue?vue&type=script&lang=ts"
export * from "./HelpPage.vue?vue&type=script&lang=ts"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=610b8160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b8160",
  null
  
)

export default component.exports